var _path, _g, _g2, _g3, _g4, _polygon;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoveragePeriod(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 184 86",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Up to 12 Years of Coverage") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "coverageSt0",
    d: "M144.5,86H0V1h144.5l29.9,42.5L144.5,86z M1,85h143l29.2-41.5L144,2H1V85z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "coverageSt1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "coverageSt0",
    d: "M45.5,71.2h10.2V38.4h-8.2v-3.8c4.1-0.7,7.1-1.8,9.5-3.3h4.5v39.8h9.2V76H45.5V71.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "coverageSt0",
    d: "m73.8 72.4c13.3-13 21-21.3 21-28.5 0-5.1-2.8-8.7-8.5-8.7-3.7 0-6.9 2.4-9.5 5.3l-3.3-3.2c3.7-4.2 7.7-6.9 13.4-6.9 8.3 0 13.4 5.3 13.4 13.1 0 8.7-7.8 16.7-18.7 27.8 2.5-0.2 5.2-0.4 7.5-0.4h13.4v5h-28.7v-3.5z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "coverageSt1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "coverageSt2",
    d: "m10.5 18.8c0-5.9 3.5-9.5 8.1-9.5 2.2 0 4 1.1 5.1 2.3l-1.3 1.4c-1-1-2.2-1.7-3.8-1.7-3.4 0-5.7 2.8-5.7 7.4s2.2 7.5 5.7 7.5c1.8 0 3.1-0.7 4.3-2l1.3 1.4c-1.5 1.7-3.3 2.7-5.6 2.7-4.7 0-8.1-3.5-8.1-9.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "coverageSt2",
    d: "m26 18.7c0-5.9 3.2-9.4 7.8-9.4s7.9 3.6 7.9 9.4c0 5.9-3.2 9.6-7.9 9.6s-7.8-3.7-7.8-9.6zm13.2 0c0-4.6-2.2-7.4-5.4-7.4s-5.4 2.8-5.4 7.4 2.1 7.5 5.4 7.5 5.4-2.9 5.4-7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "coverageSt2",
    d: "m43.2 9.6h2.5l2.9 9.9c0.6 2.2 1.1 3.9 1.8 6h0.1c0.7-2.1 1.1-3.9 1.8-6l3.1-9.9h2.4l-6 18.4h-2.7l-5.9-18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "coverageSt2",
    d: "M60.5,9.6H71v2h-8.2v5.7h6.9v2h-6.9V26h8.5v2H60.5V9.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "coverageSt2",
    d: "m75.6 9.6h5.7c3.8 0 6.4 1.3 6.4 5.2 0 2.9-1.6 4.5-4.1 5.2l4.7 8h-2.7l-4.4-7.8h-3.3v7.8h-2.4v-18.4zm5.4 8.7c2.9 0 4.4-1.2 4.4-3.5 0-2.4-1.6-3.3-4.4-3.3h-3.1v6.8h3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "coverageSt2",
    d: "m95.5 9.6h2.7l6.2 18.4h-2.5l-1.7-5.6h-6.7l-1.8 5.6h-2.4l6.2-18.4zm-1.4 10.9h5.5l-0.9-2.8c-0.7-2-1.3-4.1-1.8-6.2h-0.1c-0.6 2.1-1.1 4.1-1.8 6.2l-0.9 2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "coverageSt2",
    d: "m106 18.8c0-5.9 3.6-9.5 8.4-9.5 2.5 0 4.2 1.1 5.3 2.3l-1.3 1.5c-0.9-1-2.1-1.7-3.9-1.7-3.7 0-6 2.8-6 7.4s2.2 7.5 6.1 7.5c1.3 0 2.6-0.4 3.3-1.1v-4.8h-3.9v-1.9h6v7.7c-1.2 1.2-3.2 2.1-5.7 2.1-4.9 0-8.3-3.5-8.3-9.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "coverageSt2",
    d: "M124.6,9.6h10.6v2H127v5.7h6.9v2H127V26h8.5v2h-10.9V9.6z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "coverageSt1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "coverageSt0",
    d: "m111.9 47.9l-3.9-8h1.8l1.7 3.7c0.4 1 0.8 1.9 1.3 2.9h0.1c0.4-1 0.9-1.9 1.3-2.9l1.7-3.7h1.8l-4 8v5.1h-1.7v-5.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "coverageSt0",
    d: "m119.6 39.9h4.1c2.7 0 4.6 1 4.6 3.7 0 2-1.2 3.2-2.9 3.7l3.3 5.7h-1.9l-3.2-5.5h-2.4v5.5h-1.7v-13.1zm3.8 6.2c2 0 3.2-0.8 3.2-2.5s-1.1-2.3-3.2-2.3h-2.2v4.9h2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "coverageSt0",
    d: "m130 51.3l0.9-1.1c1 1 2.3 1.6 3.7 1.6 1.7 0 2.7-0.9 2.7-2.1 0-1.3-1-1.8-2.2-2.3l-1.9-0.8c-1.2-0.5-2.6-1.4-2.6-3.4s1.7-3.5 4.1-3.5c1.6 0 3 0.7 3.9 1.6l-0.9 1.1c-0.8-0.8-1.8-1.2-3-1.2-1.5 0-2.4 0.7-2.4 1.9 0 1.3 1.1 1.7 2.2 2.2l1.9 0.8c1.5 0.6 2.7 1.6 2.7 3.5 0 2.1-1.7 3.7-4.5 3.7-1.9-0.1-3.5-0.8-4.6-2z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "coverageSt1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "coverageSt2",
    d: "m10.2 45.2v-5.4h1.2v5.4c0 2.2 0.9 2.9 2.1 2.9s2.2-0.7 2.2-2.9v-5.4h1.1v5.4c0 2.9-1.4 4-3.3 4s-3.3-1.1-3.3-4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "coverageSt2",
    d: "m19 39.8h2.6c2.1 0 3.5 0.7 3.5 2.7 0 1.9-1.4 2.8-3.4 2.8h-1.5v3.7h-1.2v-9.2zm2.5 4.6c1.6 0 2.4-0.6 2.4-1.9s-0.8-1.8-2.4-1.8h-1.3v3.6h1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "coverageSt2",
    d: "M31,40.8h-2.8v-1h6.7v1h-2.8V49H31V40.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "coverageSt2",
    d: "m35.4 44.4c0-2.9 1.6-4.7 3.9-4.7s3.9 1.8 3.9 4.7c0 3-1.6 4.8-3.9 4.8s-3.9-1.9-3.9-4.8zm6.6 0c0-2.3-1.1-3.7-2.7-3.7s-2.7 1.4-2.7 3.7 1.1 3.8 2.7 3.8c1.7-0.1 2.7-1.5 2.7-3.8z"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "coverageSt0",
    points: "152.2 86.8 149.8 85.2 178.2 43.5 149.8 1.8 152.2 0.2 181.8 43.5"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoveragePeriod);
export default __webpack_public_path__ + "static/media/coverage-period.464937e88b6da68317d7ee6682ca959a.svg";
export { ForwardRef as ReactComponent };